import React, { useEffect, useState } from "react";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import styles from "./styles.module.css";
import studentPicture from "../../assets/img/generic/student-girl.jpg";
import alertSound from "../../assets/img/sounds/ding-dong.mp3";

function DriverArrivalStatusList({ notificationReceived }) {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const [students, setStudents] = useState([]);
  const [centerId, setCenterId] = useState(savedCenterId || null);

  // const [students, setStudents] = useState([
  //   {
  //     id: 1,
  //     studentName: "Orli Castaneda",
  //     rollNo: "RO-15234",
  //     class: "Class 1",
  //     section: "A",
  //     careTakerName: "Care Taker 1",
  //     driverName: "Liam",
  //     status: "ApproachingZone",
  //   },
  //   {
  //     id: 2,
  //     studentName: "Emma Smith",
  //     rollNo: "RO-15235",
  //     class: "Class 2",
  //     section: "A",
  //     careTakerName: "Care Taker 2",
  //     driverName: "Brown",
  //     status: "On the way",
  //   },
  //   {
  //     id: 3,
  //     studentName: "Liam Brown",
  //     rollNo: "RO-15236",
  //     class: "Class 3",
  //     section: "A",
  //     careTakerName: "Care Taker 3",
  //     driverName: "Smith",
  //     status: "On the way",
  //   },
  // ]);

  const getStudentsPickupStatus = async () => {
    try {
      const response = await get(
        `MobileApp/GetStudentPicUpStatus?centerId=${centerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setStudents(response?.pickupStatusStudentDtos);
    } catch (error) {
      console.error("Error fetching centers:", error);
    }
  };

  let isSpeaking = false; // Global flag to track the speaking state

  const speakStudentAnnouncement = (name, rollNo, status) => {
    if (isSpeaking) {
      console.log(
        "Already speaking or playing a notification. Skipping this request."
      );
      return;
    }

    const notificationSound = new Audio(alertSound);

    // Define messages based on the status
    let message = "";

    if (status === "Started") {
      message = `Attention! Dear ${name}, Roll Number ${rollNo}, your ride is on its way.`;
    } else if (status === "ApproachingZone") {
      message = `Attention! Dear ${name}, Roll Number ${rollNo}, your ride is approaching, please get ready.`;
    } else if (status === "PickupZone") {
      message = `Attention! Dear ${name}, Roll Number ${rollNo}, your ride is nearby, and will arrive shortly, please be prepared.`;
    } else if (status === "Arrived") {
      message = `Attention! Dear ${name}, Roll Number ${rollNo}, your ride has arrived, please proceed to the vehicle.`;
    }

    if (!message) {
      console.warn(`No message defined for status: ${status}`);
      return;
    }

    // Set speaking flag to true
    isSpeaking = true;

    // Play the notification sound
    notificationSound.play().catch((error) => {
      console.error("Error playing notification sound:", error);
      isSpeaking = false; // Reset flag if sound playback fails
    });

    notificationSound.onended = () => {
      // After sound finishes, proceed with speech synthesis
      if ("speechSynthesis" in window) {
        // Cancel any ongoing speech
        speechSynthesis.cancel();

        const utterance = new SpeechSynthesisUtterance(message);
        utterance.rate = 0.9;
        utterance.pitch = 1.3;
        utterance.volume = 1;

        // Select a female voice
        const voices = window.speechSynthesis.getVoices();
        const femaleVoice =
          voices.find((voice) => voice.name.toLowerCase().includes("female")) ||
          voices.find((voice) => voice.lang === "en-US");

        if (femaleVoice) {
          utterance.voice = femaleVoice;
        }

        // Reset the speaking flag when speech ends
        utterance.onend = () => {
          isSpeaking = false;
          console.log("Speech completed.");
        };

        // Speak the message
        speechSynthesis.speak(utterance);
        console.log(`Speaking: ${message}`);
      } else {
        console.warn("Speech Synthesis is not supported in this browser.");
        isSpeaking = false; // Reset flag if speech synthesis isn't available
      }
    };

    notificationSound.onerror = () => {
      console.error("Error playing notification sound.");
      isSpeaking = false; // Reset flag if there's an error with the sound
    };
  };

  useEffect(() => {
    getStudentsPickupStatus();
  }, []);

  useEffect(() => {
    if (notificationReceived?.isSuccess) {
      getStudentsPickupStatus();
    }
  }, [notificationReceived]);

  useEffect(() => {
    const targetStudent = students.find((student) =>
      ["Started", "ApproachingZone", "PickupZone", "Arrived"].includes(
        student.status
      )
    );

    if (targetStudent) {
      speakStudentAnnouncement(
        targetStudent.studentName,
        targetStudent.rollNo,
        targetStudent.status
      );
    }
  }, [students]);

  useEffect(() => {
    const initializeSpeech = () => {
      const utterance = new SpeechSynthesisUtterance("");
      speechSynthesis.speak(utterance);
    };

    window.addEventListener("click", initializeSpeech, { once: true });
  }, []);

  const testSpeech = () => {
    if ("speechSynthesis" in window) {
      const message = "Hello, this is a test message!";
      const utterance = new SpeechSynthesisUtterance(message);
      utterance.rate = 1;
      utterance.pitch = 1;
      speechSynthesis.speak(utterance);
    } else {
      console.warn("Speech Synthesis is not supported in this browser.");
    }
  };

  return (
    <div className={styles["driver-arrival-status-wrapper"]}>
      <table className={`${styles["driver-arrival-status-table"]}`}>
        <thead>
          <tr>
            <th>Sr No.</th>
            <th>Student</th>
            <th>Care Taker</th>
            <th>Driver</th>
            <th>Trip Status</th>
          </tr>
        </thead>
        <tbody>
          {students.length === 0 ? (
            <tr>
              <td colSpan="5">
                <div className="text-center">
                  There are no records to display
                </div>
              </td>
            </tr>
          ) : (
            students?.map((student, index) => {
              let studentPicture =
                student.imagePath === "" || student.imagePath === "string"
                  ? `${process.env.PUBLIC_URL}/image/team/avatar-placeholder.jpg`
                  : `${process.env.REACT_APP_LIVE_DOMAIN_URL}ExternalImages/${student.imagePath}`;
              return (
                <tr
                  key={student.studentId}
                  className={`${styles.tableRowAnimate} ${
                    student.status === "Arrived" ? styles.arrived : ""
                  }`}
                >
                  <td>{index + 1}</td>
                  <td>
                    <div className={styles.studentWrapper}>
                      <div className={styles.studentPicture}>
                        <img src={studentPicture} alt="Image" />
                      </div>
                      <div className={styles.studentNameAndRollNo}>
                        <div className={styles.studentName}>
                          {student.studentName}
                        </div>
                        <div className={styles.studentRollNo}>
                          <strong
                            style={{ width: "60px", display: "inline-block" }}
                          >
                            Roll No:
                          </strong>{" "}
                          {student.rollNo}
                        </div>
                        <div className={styles.studentRollNo}>
                          <strong
                            style={{ width: "60px", display: "inline-block" }}
                          >
                            Class:
                          </strong>{" "}
                          {student.class}
                        </div>
                        <div className={styles.studentRollNo}>
                          <strong
                            style={{ width: "60px", display: "inline-block" }}
                          >
                            Section:
                          </strong>{" "}
                          {student.section}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>{student.careTakerName}</td>
                  <td>{student.driverName}</td>
                  <td>
                    <div
                      className={`fs-9 badge text-bg-${
                        student.status === "Arrived" ? "success" : "secondary"
                      }`}
                    >
                      {student.status}
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
      <button
        className="btn btn-primary mt-3 d-none"
        onClick={() =>
          speakStudentAnnouncement("Emma Smith", "RO-15234", "ApproachingZone")
        }
      >
        Test Alert
      </button>
    </div>
  );
}

export default DriverArrivalStatusList;
